import { extendTheme } from "@mui/joy/styles";

export const generateTheme = (lan: "en" | "fa") => {
  const fontFamily = lan === "fa" ? "dana VF" : "Inter, sans-serif";

  return extendTheme({
    fontFamily: {
      body: fontFamily,
      display: fontFamily,
      code: "monospace",
      fallback: "sans-serif",
    },

    radius: {
      xs: "6px",
      sm: "10px",
      md: "14px",
      lg: "22px",
      xl: "30px",
    },

    colorSchemes: {
      light: {
        palette: {
          primary: {
            50: "#eef4ff",
            100: "#dbe8ff",
            200: "#b8ccfa",
            300: "#86aef6",
            400: "#4f83ef",
            500: "#185de7",
            600: "#1249b7",
            700: "#0f388a",
            800: "#0a2868",
            900: "#071d45",
          },
          background: {
            body: "#f5f7fb",
            surface: "rgba(255,255,255,0.82)",
            level1: "#ffffff",
            level2: "#eef2f7",
            level3: "#e2e8f0",
          },
        },
      },

      dark: {
        palette: {
          primary: {
            50: "#eef4ff",
            100: "#dbe8ff",
            200: "#b8ccfa",
            300: "#86aef6",
            400: "#4f83ef",
            500: "#6f9bff",
            600: "#185de7",
            700: "#1249b7",
            800: "#0f388a",
            900: "#0a2868",
          },
          background: {
            body: "#090c13",
            surface: "rgba(15,23,42,0.78)",
            level1: "#111827",
            level2: "#1f2937",
            level3: "#334155",
          },
        },
      },
    },

    typography: {
      h1: {
        fontFamily,
        fontWeight: 900,
        fontSize: "clamp(2.5rem, 6vw, 4.6rem)",
        lineHeight: 1.02,
        letterSpacing: "-0.055em",
      },
      h2: {
        fontFamily,
        fontWeight: 850,
        fontSize: "clamp(2rem, 4vw, 3rem)",
        lineHeight: 1.1,
        letterSpacing: "-0.035em",
      },
      h3: {
        fontFamily,
        fontWeight: 800,
        fontSize: "clamp(1.55rem, 3vw, 2.2rem)",
        lineHeight: 1.18,
      },
      "title-lg": {
        fontFamily,
        fontWeight: 800,
        fontSize: "clamp(1.25rem, 2vw, 1.65rem)",
        lineHeight: 1.25,
      },
      "title-md": {
        fontFamily,
        fontWeight: 750,
        fontSize: "clamp(1.05rem, 1.6vw, 1.25rem)",
        lineHeight: 1.35,
      },
      "title-sm": {
        fontFamily,
        fontWeight: 750,
        fontSize: "clamp(0.95rem, 1.2vw, 1.05rem)",
        lineHeight: 1.45,
      },
      "body-lg": {
        fontFamily,
        fontSize: "clamp(1.02rem, 1.35vw, 1.18rem)",
        lineHeight: 1.85,
      },
      "body-md": {
        fontFamily,
        fontSize: "clamp(0.94rem, 1.1vw, 1rem)",
        lineHeight: 1.75,
      },
      "body-sm": {
        fontFamily,
        fontSize: "clamp(0.82rem, 1vw, 0.92rem)",
        lineHeight: 1.65,
      },
      "body-xs": {
        fontFamily,
        fontSize: "clamp(0.72rem, 0.9vw, 0.8rem)",
        lineHeight: 1.5,
      },
    },

    components: {
      JoyButton: {
        styleOverrides: {
          root: {
            fontWeight: 800,
            borderRadius: "999px",
          },
        },
      },
      JoyCard: {
        styleOverrides: {
          root: {
            borderRadius: "24px",
          },
        },
      },
      JoyInput: {
        styleOverrides: {
          root: {
            borderRadius: "18px",
          },
        },
      },
      JoyTextarea: {
        styleOverrides: {
          root: {
            borderRadius: "20px",
          },
        },
      },
    },
  });
};
